<template>
	<section v-if="!$root.isEmpty(tracePromotionData)">
		<b-table responsive="lg" stacked="md" striped hover :fields="columns"
			:items="tracePromotionData">
			<template #cell(amounts)="row">
				<b-table :items="row.item.amounts" small striped></b-table>
			</template>
			<template #cell(settingApplied)="{item}">
				<b-table
				striped
				hover
				small
				class="table-condensed"
				:items="[{...item.settingApplied}]"
				:fields="columnsTraceSettingPromo"
				>
					<template v-slot:cell(modifierAmount)="row">
						<span v-if="item.rateModifierType=='fixed_rate'">
							${{row.item.modifierAmount}}
						</span>
						<span v-else>
							<span v-if="row.item.modifierSign=='1'">+</span>
							<span v-else>-</span>
							{{row.item.modifierAmount}}
							<span v-if="item.rateModifierType=='percent'">(%)</span>
							<span v-else>($)</span>
						</span>
					</template>
					<template v-slot:cell(applyReturn)="row">
						<span v-if="row.item.applyReturn">Si</span>
						<span v-else>No</span>
					</template>
				</b-table>
			</template>
		</b-table>
	</section>
	<section v-else>
		<span>No existe promociones relacionados</span>
	</section>
</template>

<script>
  export default {
    props: {
      tracePromotion: {
        type:[Object,Array],
        required: true
      }
    },
	data(){
		return {
			columns:[
				{'key':'name', 'label':'Nombre'},
				{'key':'amounts', 'label':'Resumen'},
				{'key':'comments', 'label':'Comentarios'},
				{'key':'settingApplied', 'label':'Conf. aplicada'},
			],
			columnsTraceSettingPromo:[
				{ key: "serviceTypeData.name", label: "Service type" },
				{ key: "fromZoneData.name", label: "Zona Pickup" },
				{ key: "toZoneData.name", label: "Zona dropoff" },
				{ key: "modifierAmount", label: "Precio" },
				{ key: "applyReturn", label: "¿Aplica Retorno?" }
			]
		}
	},
    computed: {
		tracePromotionData(){
			try{
				if (Array.isArray(this.tracePromotion) && this.tracePromotion.length > 0) {//cuando aplica promocion en RT, se desglosa por ride, por eso se contempló aqui
					return this.tracePromotion;
				}else if(typeof this.tracePromotion === 'object' && Object.keys(this.tracePromotion).length > 0){
					return [this.tracePromotion]
				}
			}catch(err){
				console.log(err)
			}
			return null;//si solo envian objeto, lo convertimos en array

		}
    },
    methods: {
    },
	mounted(){

	}

  }
</script>

